export const SET_BOARD = "SET_BOARD";
export const SET_SELECTED_BOARD = "SET_SELECTED_BOARD";
export const SET_BOARD_OPTIONS = "SET_BOARD_OPTIONS";
export const SET_WEIGHT = "SET_WEIGHT";
